
    .responsive3839243538__root .CircularProgressBar984997895__root {
        --CircularProgressBar984997895-color-fore-arc: #116dff;
        --CircularProgressBar984997895-color-back-arc: #e2e3ea;
        --CircularProgressBar984997895-color-error-fore-arc: #ee4437;
        --CircularProgressBar984997895-color-progress-indicator: #000624;
        --CircularProgressBar984997895-margin-top-progress-indicator: 8px;
        --CircularProgressBar984997895-margin-bottom-progress-indicator: 6px;
        --CircularProgressBar984997895-small-arc-size: 24px;
        --CircularProgressBar984997895-medium-arc-size: 56px;
        --CircularProgressBar984997895-large-arc-size: 224px;
        --CircularProgressBar984997895-small-icon-size: 8px;
        --CircularProgressBar984997895-medium-icon-size: 24px;
        --CircularProgressBar984997895-large-icon-size: 40px;
    }

/* st-namespace-reference="../../../../src/skins/responsive/CircularProgressBar.st.css" */